// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import {changeOwed} from "../../WorkIssuanceOwed/owedSlice";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import PanToolIcon from "@mui/icons-material/PanTool";
import PaidIcon from "@mui/icons-material/Paid";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function PaidOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const performPaid = () => {
        console.log("performPaid");
        // dispatchData(changeOwed({paidState: true, owedNewStatus: 'Paid'}));
        dispatchData(changeWorkIssuance({newStatus:  '2351', updateCdpStatus: true}));
        onMenuClose();
    };

    return (

        <Box>
            {(
                    rowCdpStatus === "2339" ||    rowCdpStatus === "2039"
                ) && showOwed === true &&
                <MenuItem onClick={performPaid}>
                    <ListItemIcon>
                        <PaidIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Pay</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
